import { css } from '@emotion/react';

export const achievementTileDialogBody = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;

  padding: 0 20px 20px 20px;
  width: 100%;
`;

export const achievementTileDialogText = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  text-align: center;
`;
